import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class Salesforce {
  async getObjects(Workspace_id, Stage_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/salesforce/${Stage_id}`)).data;
  }

  async getFields(Workspace_id, Stage_id, object) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/salesforce/${Stage_id}/${object}`)).data;
  }

  async runQuery(Workspace_id, Stage_id, postData) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/salesforce/${Stage_id}/runquery`, postData)).data;
  }
}
